// @ts-nocheck
// Accreditations — with NCF → NEP 2020 rename from v2 patch baked in.

export const ACCREDITATIONS = [
  { id: "nabet", label: "NABET", path: "/admissions-assured/standards/qci.svg" },
  { id: "qci", label: "QCI", path: "/admissions-assured/standards/qci.svg" },
  { id: "ncert", label: "NCERT", path: "/admissions-assured/standards/ncert.svg" },
  { id: "nep", label: "NEP 2020", path: "/admissions-assured/standards/nep-2020.svg" },
  { id: "ugc", label: "UGC", path: "/admissions-assured/standards/ugc.svg" },
  { id: "aicte", label: "AICTE", path: "/admissions-assured/standards/aicte.svg" },
  { id: "bhashini", label: "Bhashini", path: "/admissions-assured/standards/bhashini.svg" },
  { id: "manodarpan", label: "Manodarpan", path: "/admissions-assured/standards/manodarpan.svg" },
];
